export default __webpack_public_path__ + "static/media/argentan6.c3a41643.jpg";